import Dexie, { Table } from 'dexie';

export interface RecentlyViewedDataset {
  id: string;                           // repo path for github, dataset UUID for uploaded
  name: string;                         // Display name
  source_type: 'github' | 'uploaded';   // Source type
  timestamp: number;                    // Last viewed timestamp
}

export class DatasetsRecentlyViewedDB extends Dexie {
  recentlyViewed!: Table<RecentlyViewedDataset>;

  constructor() {
    super('datasets-recently-viewed');
    
    this.version(1).stores({
      recentlyViewed: 'id, source_type, timestamp'
    });
  }
}

export const datasetsRecentlyViewedDB = new DatasetsRecentlyViewedDB(); 